import "./filterStyles.css";
import { useState, useEffect } from "react";

const CustomeDateSearch = ({ closeModal, setFetchCustomTrans, setSalesTimeLine, disableDefault }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isDatesValid, setIsDatesValid] = useState(false);

  useEffect(() => {
    return () => {
      !disableDefault && setFetchCustomTrans(null);
    };
  }, []);

  useEffect(() => {
    console.log(fromDate, toDate);
    if (fromDate && toDate) {
      setIsDatesValid(true);
      /*  updateDateRange({ fromDate, toDate }); */
    }
  }, [fromDate, toDate]);

  const fetchCustomTrans = () => {
    setSalesTimeLine(fromDate.toString() + " - " + toDate.toString());
    setFetchCustomTrans({ fromDate, toDate });
    closeModal(false);
    /*  if (fromDate && toDate) {
      setFetchCustomTrans({ fromDate, toDate });
      setSalesTimeLine("Custom");
      closeModal(false);
    } */
  };

  return (
    <div
      onClick={() => {
        closeModal(false);
        setSalesTimeLine((prev) => prev);
      }}
      className='dateSearchWrapper'
    >
      <div onClick={(e) => e.stopPropagation()} className='customDatePicker'>
        <h3> Select custom dates </h3>
        <div className='dateInputeFr33'>
          <div>
            <p> from </p>
            <input
              id='fromDate'
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className='chooseDateInter46'
              type='date'
              max={toDate ? toDate : new Date(Date.now() - 86400000).toISOString().split("T")[0]}
            />
          </div>
          <div>
            <p> to </p>
            <input
              id='toDate'
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className='chooseDateInter46'
              type='date'
              min={fromDate}
              max={new Date(Date.now() - 86400000).toISOString().split("T")[0]}
            />
          </div>
        </div>

        {isDatesValid ? (
          <button onClick={fetchCustomTrans}>Search</button>
        ) : (
          <button
            style={{
              cursor: "not-allowed",
              opacity: "0.5",
            }}
          >
            Search
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomeDateSearch;
